<div style="font-size: 20px; font-weight: 600; margin-bottom: 12px">Your Quote</div>

<div *ngIf="showDiscountPrice">
  <div style="margin-bottom: 8px">
    <div>
      <span style="font-size: 42px; font-weight: bold; color: #003366">
        {{ yourQuotePrice | currency : 'GBP' : 'symbol' : '1.2-2' }}</span
      ><span style="font-size: 20px; text-decoration: line-through">{{
        yourOriginalPrice | currency : 'GBP' : 'symbol' : '1.2-2'
      }}</span>
    </div>
    <div>
      <span style="font-size: 16px; color: #888" class="pt-2">
        <strong>{{
          yourQuotePrice * 1.2 | bankersRound : 2 | currency : 'GBP' : 'symbol' : '1.2-2'
        }}</strong>
        <span style="font-size: 14px">inc VAT</span>
      </span>
    </div>
  </div>
</div>

<div
  *ngIf="!showDiscountPrice"
  style="font-size: 42px; line-height: 1; font-weight: bold; color: #003366; margin-bottom: 6px"
>
  {{ yourQuotePrice | currency : 'GBP' : 'symbol' : '1.2-2' }}

  <div style="font-size: 16px; color: #888" class="pt-2">
    <strong>£{{ yourQuotePrice * 1.2 | bankersRound : 2 }}</strong>
    <span style="font-size: 14px">inc VAT</span>
  </div>
</div>

<div (click)="showDialog()" class="discount-code">
  <div *ngIf="!showDiscountPrice" style="font-size: 18px">Have a discount code ?</div>
  <div *ngIf="showDiscountPrice" style="font-weight: 600; font-size: 14px">
    Coupon: {{ quote.discountCode }} Applied -

    <span style="font-size: 16px; font-weight: bold; color: #003366"
      >Saving: {{ discountAmount | currency : 'GBP' : 'symbol' : '1.2-2' }}</span
    >
  </div>
</div>
